import { useEffect, useState } from 'react';
import { APP_NAME } from '../constants';
import { getBrandName, getContactEmail, getContactPhone } from './appSettings';

/**
 * Charge MARQUE + coordonnées contact depuis app_settings.
 */
export function useBrandSettings() {
  const [brandName, setBrandName] = useState(APP_NAME);
  const [contactEmail, setContactEmail] = useState('');
  const [contactPhone, setContactPhone] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;

    const load = async () => {
      try {
        const [marque, email, phone] = await Promise.all([
          getBrandName(),
          getContactEmail(),
          getContactPhone(),
        ]);
        if (cancelled) return;
        setBrandName(marque || APP_NAME);
        setContactEmail(email || '');
        setContactPhone(phone || '');
      } catch (err) {
        console.warn('useBrandSettings:', err);
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    load();
    return () => {
      cancelled = true;
    };
  }, []);

  return { brandName, contactEmail, contactPhone, loading };
}
